<template>
  <div :class="['drawer-container',qwMap?'qwMap':'']">
    <!-- <el-scrollbar style="height:100%; overflow-y: hidden"> -->
    <div>
      <map-head-check-box class="m-c" ref="maphead" :location="location" @set-condition="setCondition"></map-head-check-box>
      <company-card-list v-loading.lock="loading" element-loading-text="耐心等待小T为您大数据计算中…" element-loading-spinner="el-icon-loading" @isUnlock-Change="isUnlockChange" :companyType="5" class="m-c ccl"
        :batchActions="batchActions" ref="cardlist" :list="data" @handle-page-num="handlePageNum" @handle-page="handlePage">
        <div class="searchBar">
          <span class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家企业</span>
        </div>
      </company-card-list>
    </div>
    <!-- </el-scrollbar> -->
    <slot></slot>
  </div>
</template>

<script>
import mapHeadCheckBox from '@/views/commercialMap/components/mapHeadCheckBox'
import companyCardList from '@/views/clue/components/companyCardList'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { X_BLOCK } from '@/utils/iframeUtils'
import { proximity } from '../api/index'

export default {
  name: 'drawerEnterpriseList',
  components: { mapHeadCheckBox, companyCardList },
  props: {
    location: {
      type: Object,
      default: () => ({ site: null, latitude: null, longtitude: null, distance: 0 })
    }
  },
  watch: {
  },
  data() {
    return {
      pageNum: 1,
      loading: false,
      condition: {},
      total: 0,
      data: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      qwMap: false, // 是否是嵌套
      isUnlock: false
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    _totalElements() {
      return this.total
      if (this.total < 100) return this.total
      if (this.total < 200000) return `${this.total.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    }
  },
  created() {
  },
  mounted() {
    if (window[X_BLOCK]) {
      console.log('X_BLOCK')
      this.qwMap = true
    }
    this.initData()
  },
  methods: {
    // 过滤解锁
    isUnlockChange(val) {
      this.isUnlock = val
      this.setCondition(val)
    },
    setCondition(val) {
      this.data.pageNum = 1
      if (val && JSON.stringify(val) !== '{}') {
        this.condition = val
      } else {
        this.condition = {}
      }
      this.loadData(this.condition)
    },
    handlePage(val) {
      if (this.data.pageNum !== val) {
        this.currentChange(val)
      }
    },
    handlePageNum(val) {
      this.data.pageNum = 1
      this.data.pageSize = val
      this.loadData(this.condition)
    },
    dragRefresh() {
      this.$refs.maphead.refreshDatekey()
    },
    initData() {
      this.condition = {}
      this.currentChange(1)
    },
    currentChange(num) {
      this.data.pageNum = num
      this.loadData(this.condition)
    },
    async loadData(val) {
      const { distance, latitude, longtitude, site } = this.location
      if (!site) return
      this.data.tableData = []
      this.loading = true
      const pageNum = this.data.pageNum
      const pageSize = this.data.pageSize
      const isUnLock = this.isUnlock ? 1 : 0
      // if (val.regStatus) {
      //   val.regStatus = val.regStatus == '' ? [] : [val.regStatus]
      // }
      const params = { distance, latitude, longtitude, pageNum, pageSize, ...val, isUnLock, word: this.$route.query.word && this.$route.query.word.trim() }
      const { data } = await proximity(params)
      const { total, items } = data || { total: 0, items: [] }
      this.total = total
      this.data = { ...this.data, total: total, tableData: items, }
      // this.data = { ...this.data, total: Math.min(total, 5000), tableData: items }
      this.loading = false
    }
  },
  destroyed() {
  }
}

</script>
<style lang='scss' scoped>
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
.m-c {
  width: 1011px;
  margin: 0 auto;
  margin-bottom: 46px;
}
.drawer-container {
  // width: 1036px;
  width: 1055px;
  height: 100vh;
  padding: 12px 0;
  // background-color: #f1f2f4;
  background-color: #f5f6f8;
  &.qwMap {
    width: 920px;
    .m-c {
      width: 96%;
    }
  }
}
.ccl {
  margin-top: 20px;
  /deep/ .recommend {
    margin: 0;
  }
}

.drawer-container /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
.drawer-container /deep/ .searchContent .setCheckBox {
  display: flex;
  // width: 100%;
  justify-content: center;
  align-items: center;
  padding-left: 17px;
  box-sizing: border-box;
}
.searchBar {
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(52, 57, 81, 0.7);
  }
}
::v-deep {
  .el-loading-spinner {
    .el-loading-text {
      font-weight: 400;
      color: #999999;
      font-size: 13px;
      margin-top: 14px;
    }
    .el-icon-loading:before {
      content: url("~@/assets/gbIcon/loading_icon.png");
    }
  }

  .el-scrollbar__wrap {
    margin-right: 0 !important;
  }
}
</style>
